import React from "react"
import * as FontIcon from "react-icons/io5"

// Transform: lock-open -> IoLockOpen
const transformToIoIcon = (input: string): string => {
  return "Io" + input.replace(/(?:^|-)(\w)/g, (_, c) => c.toUpperCase())
}

interface IonIconProps {
  name?: string | null
  style?: React.CSSProperties
  className?: string | null
}

const IonIcon = ({ name, style, className }: IonIconProps) => {
  if (name) {
    const Icon = (FontIcon as Record<string, React.ComponentType<{ className?: string; style?: React.CSSProperties }>>)[transformToIoIcon(name)]
    if (Icon) {
      return <Icon className={className || "icon"} style={style} />
    }
  }
  return <div />
}

export default IonIcon
